/* eslint-disable react-hooks/exhaustive-deps */
import { withStyles, withTheme, Typography } from '@material-ui/core';

import { Grid, Table, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { IntegratedSorting, SortingState } from '@devexpress/dx-react-grid';

import { compose } from 'recompose';
import React, { useState } from 'react';
import classNames from 'classnames';

import { formatDateForInput, formatDateGeneric } from 'utilities/common';
import { formatMoney } from 'utilities/currencyFormatter';
import Spinner from 'modules/common/spinner.component';
import { Box, Divider, MenuItem, Grid as MuiGrid, TextField } from '@mui/material';
import MultiSelectDropdown from 'modules/common/multiSelectDropdownForm.component';
import { SERVICE_FILTER_TYPES, DATE_FILTER_TYPES, PAYROLL_FILTER_TYPES } from './expenseConstants';

const styles = theme => {
  const border = `1px solid ${theme.palette.grey[500]}`;
  return {
    table: {
      borderSpacing: theme.spacing(0, 2)
    },
    tableHead: {
      height: 32
    },
    cell: {
      borderTop: border,
      borderBottom: border,
      borderLeft: 0,
      borderRight: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderLeft: border
      },
      '&:last-child': {
        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        borderRight: border
      }
    },
    urgencyMenuItem: {
      justifyContent: 'center'
    },
    selectInput: {
      lineHeight: 1.75,
      paddingBottom: theme.spacing(0.5),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(0.5)
    },
    row: {
      backgroundColor: theme.palette.common.white
    },
    noDataCell: {
      paddingBottom: theme.spacing(12),
      paddingTop: theme.spacing(12),
      textAlign: 'center'
    }
  };
};

const ApprovedExpensesTableHeader = ({ expenses, setFilteredExpenses }) => {
  const [originalExpenses] = useState(expenses ?? []);

  //Filters
  const [fromDateFilter, setFromDateFilter] = useState();
  const [toDateFilter, setToDateFilter] = useState();
  const [selectedServiceFilterType, setSelectedServiceFilterType] = useState(SERVICE_FILTER_TYPES[0]);
  const [selectedDateFilter, setSelectedDateFilter] = useState(DATE_FILTER_TYPES[0]);
  const [selectedPayrollFilter, setSelectedPayrollFilter] = useState([]);

  const calculateTotalExpenses = () => {
    if (!expenses) return 0;
    return expenses.reduce((sum, record) => {
      const approvedValue = parseFloat(record.approved) || 0;
      return sum + approvedValue;
    }, 0);
  };

  const countNumberOfTxs = () => {
    //TODO - Figure out what this is
    return 2;
  };

  const dateFilterRequiresFromAndToDates = () => {
    //TODO - Use an array or properties of an object?
    switch (selectedDateFilter) {
      case DATE_FILTER_TYPES[0]:
      case DATE_FILTER_TYPES[1]:
      case DATE_FILTER_TYPES[2]:
      case DATE_FILTER_TYPES[3]:
      case DATE_FILTER_TYPES[4]:
      case DATE_FILTER_TYPES[5]:
        return false;
      default:
        return true;
    }
  };

  const handleFilterChange = setFilterValue => event => {
    setFilterValue(event.target.value);

    if (!originalExpenses || originalExpenses.length === 0) return;

    //TODO - Is there a better way to do this?
    let tempFilterExpenses = { ...originalExpenses };
    tempFilterExpenses = applyServiceFilter(tempFilterExpenses);
    tempFilterExpenses = applyDateFilter(tempFilterExpenses);
    tempFilterExpenses = applyPayrollFilter(tempFilterExpenses);
    if (dateFilterRequiresFromAndToDates()) {
      tempFilterExpenses = applyToDateFilter(tempFilterExpenses);
      tempFilterExpenses = applyFromDateFilter(tempFilterExpenses);
    } else {
      //TODO - Should we clear any current to/from dates?
    }
    setFilteredExpenses(tempFilterExpenses);
  };

  const applyFromDateFilter = value => {
    setFromDateFilter(value);

    //Some logic ...

    return expenses;
  };

  const applyToDateFilter = value => {
    setToDateFilter(value);

    //Some logic ...

    return expenses;
  };

  const applyServiceFilter = value => {
    setSelectedServiceFilterType(value);

    //Some logic ...

    return expenses;
  };

  const applyDateFilter = value => {
    selectedDateFilter(value);

    //Some logic ...

    return expenses;
  };

  const applyPayrollFilter = value => {
    setSelectedPayrollFilter(value);

    //Some logic ...

    return expenses;
  };

  const renderBox = (title, content) => (
    <Box display="flex" flexDirection="column" alignItems="center" sx={{ margin: '5px 10px' }}>
      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '0.85rem' }}>
        {title}
      </Typography>
      {content}
    </Box>
  );

  const renderDateBox = (title, value, onChange) =>
    renderBox(
      title,
      <TextField
        value={value}
        onChange={onChange}
        type="date"
        variant="standard"
        InputLabelProps={{ shrink: true }}
        sx={{
          maxWidth: '360px',
          margin: 'dense',
          '& .MuiInputBase-input': {
            fontSize: '0.85rem'
          }
        }}
      />
    );

  const renderSelectBox = (title, value, onChange, options) =>
    renderBox(
      title,
      <TextField
        select
        value={value}
        onChange={onChange}
        SelectProps={{ autoWidth: true, displayEmpty: true }}
        variant="standard"
        sx={{
          minWidth: '100px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.85rem'
          }
        }}
      >
        {options.map((item, index) => (
          <MenuItem key={index} value={item}>
            {item}
          </MenuItem>
        ))}
      </TextField>
    );

  return (
    <Box>
      <MuiGrid
        container
        spacing={1}
        justifyContent="space-between"
        alignItems="center"
        sx={{ paddingLeft: '50px', paddingRight: '50px', paddingTop: '10px' }}
      >
        <MuiGrid item>
          {renderBox(
            'Total Expenses',
            <Typography variant="body2" sx={{ paddingTop: '8px', color: '#43423a', fontWeight: 500, fontSize: '0.85rem' }}>
              {formatMoney(calculateTotalExpenses())}
            </Typography>
          )}
        </MuiGrid>
        <MuiGrid item>
          {renderBox(
            '# of Txs',
            <Typography variant="body2" sx={{ paddingTop: '8px', color: '#43423a', fontWeight: 500, fontSize: '0.85rem' }}>
              {countNumberOfTxs()}
            </Typography>
          )}
        </MuiGrid>
        <MuiGrid item>
          {renderSelectBox(
            'Service Filter',
            selectedServiceFilterType,
            handleFilterChange(setSelectedServiceFilterType),
            SERVICE_FILTER_TYPES
          )}
        </MuiGrid>
        <MuiGrid item>
          {renderSelectBox('Date Filter', selectedDateFilter, handleFilterChange(setSelectedDateFilter), DATE_FILTER_TYPES)}
        </MuiGrid>
        <MuiGrid item>{renderDateBox('From', formatDateForInput(fromDateFilter), handleFilterChange(setFromDateFilter))}</MuiGrid>
        <MuiGrid item>{renderDateBox('To', formatDateForInput(toDateFilter), handleFilterChange(setToDateFilter))}</MuiGrid>
        <MuiGrid item>
          <MultiSelectDropdown
            options={PAYROLL_FILTER_TYPES}
            label="Payroll Filter"
            selectedOptions={selectedPayrollFilter}
            setSelectedOptions={setSelectedPayrollFilter}
          />
        </MuiGrid>
        <MuiGrid item>
          <Box display="flex" justifyContent="center" alignItems="flex-end" height="100%">
            {/* TODO - Do we want to download just the filtered approved expenses? */}
            {/* <DownloadCsvLink data={originalExpenses} fields={expenseLineItemFields} /> */}
          </Box>
        </MuiGrid>
      </MuiGrid>
      <Divider light sx={{ marginTop: '20px' }} />
    </Box>
  );
};

const ApprovedExpenses = props => {
  const { classes, approvedLineItems, isLoading, history, id } = props;

  const [lineItems, setLineItems] = useState(approvedLineItems || []);

  const [sorting, setSorting] = useState([{ columnName: 'payrollDate', direction: 'desc' }]);
  const [tableColumnExtensions] = useState([{ columnName: 'description', width: 250, wordWrapEnabled: true }]);

  const changeSorting = sorting => setSorting(sorting);

  const formatDate = key => record => {
    return formatDateGeneric(record[key]);
  };

  const headerCell = props => {
    return props.column.title ? <TableHeaderRow.Cell {...props} /> : null;
  };

  const headerRowComponent = props => {
    return <TableHeaderRow.Row className={classes.tableHead} {...props} />;
  };

  const rowComponent = props => {
    return <Table.Row className={classes.row} {...props} />;
  };

  const cellComponent = props => {
    let clickHandler = () => history.push(`/authorizations/${id}/expenses/approved/${props.row.approvedExpenseLineItemId}`);
    let pointerClass = 'handles-click';
    const className = classNames(classes.cell, pointerClass);
    return <Table.Cell onClick={clickHandler} className={className} {...props} />;
  };

  const tableComponent = props => {
    return <Table.Table className={classes.table} {...props} />;
  };

  const noDataCellComponent = props => {
    const content = isLoading ? <Spinner logo /> : 'No Records were returned.';
    const { getMessage, ...rest } = props;
    return (
      <Table.Cell {...rest} className={classes.noDataCell}>
        <Typography>{content}</Typography>
      </Table.Cell>
    );
  };

  const [columns] = useState([
    { name: 'expenseCode', title: 'Expense Code' },
    { name: 'payrollDate', title: 'Payroll Date', getCellValue: formatDate('payrollDate') },
    {
      name: 'amount',
      title: 'Amount',
      getCellValue: record => <Typography>{formatMoney(isNaN(parseFloat(record.amount)) ? 0 : record.amount)}</Typography>
    },
    { name: 'description', title: 'Description' },
    { name: 'currency', title: 'Currency' },
    { name: 'service', title: 'Service' },
    { name: 'category', title: 'Category' }
  ]);

  return (
    <div>
      <ApprovedExpensesTableHeader expenses={lineItems} setFilteredExpenses={setLineItems} />
      <Grid rows={lineItems ? lineItems : []} columns={columns}>
        <SortingState sorting={sorting} onSortingChange={changeSorting} />
        <IntegratedSorting />
        <Table
          columnExtensions={tableColumnExtensions}
          rowComponent={rowComponent}
          tableComponent={tableComponent}
          cellComponent={cellComponent}
          noDataCellComponent={noDataCellComponent}
        />
        <TableHeaderRow rowComponent={headerRowComponent} cellComponent={headerCell} showSortingControls />
      </Grid>
    </div>
  );
};

ApprovedExpenses.defaultProps = { isLoading: false };

export default compose(withStyles(styles), withTheme)(ApprovedExpenses);
